import gql from 'graphql-tag';

const GET_SINGLE_CAMPAIGN = gql`
	query GetSingleCampaign($id: ID!) {
		campaign(id: $id) {
			id
			name
			active
			target {
				type
				selected {
					id
					image
					title
					handle
				}
				ids
				countries {
					include_active 
					include
					exclude_active 
					exclude
				}
			}
			settings {
				type
				applied_discount_title
				bundles {
					text
					prefix
					font_size
					background {
						r
						g
						b
						a
					}
					color {
						r
						g
						b
						a
					}
					activeBackground {
						r
						g
						b
						a
					}
					activeColor {
						r
						g
						b
						a
					}
					list {
						id
						type
						quantity
						reward
					}
				}
				add_to_unlock {
					separator {
						text
						active
					}
					progress_primary {
						r
						g
						b
						a
					}
					progress_secondary {
						r
						g
						b
						a
					}
					progress_complete {
						r
						g
						b
						a
					}
					# reward_type
					title {
						text
						font_size
						font_weight
						color {
							r
							g
							b
							a
						}
					}
					background {
						r
						g
						b
						a
					}
					borderColor {
						r
						g
						b
						a
					}
					show_product_details {
						text
						font_size
						font_weight
						color {
							r
							g
							b
							a
						}
					}
					product_details {
						atcButton {
							text
							font_size
							font_weight
							color {
								r
								g
								b
								a
							}
						}
						atcButton_background {
							r
							g
							b
							a
						}
						atcButton_hoverBackground {
							r
							g
							b
							a
						}
						readMore {
							text
							font_size
							font_weight
							color {
								r
								g
								b
								a
							}
						}
						truncate
						truncate_length
						external
					}
					product_title {
						text
						font_size
						font_weight
						color {
							r
							g
							b
							a
						}
					}
					product_price {
						text
						font_size
						font_weight
						color {
							r
							g
							b
							a
						}
					}
					upsell_add_button {
						text
						font_size
						font_weight
						color {
							r
							g
							b
							a
						}
					}
					upsell_confirm_button {
						text
						font_size
						font_weight
					}
					show_suggestions
					recommendation_type
					products_length
					exclude_tags
					products {
						id
						image
						title
						price
						handle
						variants {
							id
							title
							price
							image
						}
						options {
							id
							name
							position
							values
						}
					}
					isActive
					show_all_locked_goals
					multi_goal_type
					goals {
						goal
						reward_type
						goal_type
						goal_text {
							text
							font_size
							color {
								r
								g
								b
								a
							}
						}
						show_goal_text
						confetti
						confetti_length
						discount {
							type
							before
							after
							reward
						}
						free_shipping {
							before
							after
							manual
						}
						manual {
							before
							after
						}
					}
					# goal
					# goal_type
					# discount {
					# 	type
					# 	before
					# 	after
					# 	reward
					# }
					# free_shipping {
					# 	before
					# 	after
					# 	manual
					# }
				}
				one_check_up_sell {
					text
					is_ticked_by_default
					include_in_atu
					highlight {
						r
						g
						b
						a
					}
					product_type
					truncate
					truncate_length
					product {
						id
						image
						price
						title
						handle
						body_html
						images {
							id
							src
						}
						options {
							id
							name
							product_id
							position
							values
						}
						variant_id
						variants {
							id
							title
							price
							image
						}
					}
				}
				modules {
					order
					random_text {
						text
						active
					}
					order_note {
						text
						active
					}
				}
			}
		}
	}
`;

export default GET_SINGLE_CAMPAIGN;
